function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as StyledComps from './StyledComps';
import PdfField from './PdfField';
import RegionRender from './RegionRender';

var PageRender = /*#__PURE__*/function (_Component) {
  _inherits(PageRender, _Component);

  var _super = _createSuper(PageRender);

  function PageRender(props) {
    var _this;

    _classCallCheck(this, PageRender);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      media: _this.props.page.background,
      regions: _this.props.page.regions || [],
      loading: true
    });

    _defineProperty(_assertThisInitialized(_this), "renderRegion", function (region) {
      var _this$props = _this.props,
          onPageChange = _this$props.onPageChange,
          computeRegionStyle = _this$props.computeRegionStyle,
          modalRef = _this$props.modalRef,
          debug = _this$props.debug,
          handleViewerEvent = _this$props.handleViewerEvent;
      return /*#__PURE__*/React.createElement(RegionRender, {
        key: region['@id'],
        region: region,
        pageRef: _this.pageRef,
        modalRef: modalRef,
        onPageChange: onPageChange,
        computeRegionStyle: computeRegionStyle,
        debug: debug,
        handleViewerEvent: handleViewerEvent
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderRegions", function (regions) {
      return regions.map(function (region) {
        return _this.renderRegion(region);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "startLoading", function () {
      if (_this.props.startLoading) {
        _this.props.startLoading();
      }

      _this.setState({
        loading: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "stopLoading", function () {
      if (_this.props.stopLoading) {
        _this.props.stopLoading();
      }

      _this.setState({
        loading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function (_ref) {
      var width = _ref.width,
          height = _ref.height;

      if (_this.pageRef !== undefined && _this.pageRef.hasOwnProperty('current') && _this.pageRef.current !== null) {
        _this.pageRef.current.style.width = width !== null ? "".concat(width, "px") : '100%';
        _this.pageRef.current.style.height = height !== null ? "".concat(height, "px") : '100%';
      }
    });

    _this.pageRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(PageRender, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          media = _this$state.media,
          regions = _this$state.regions,
          loading = _this$state.loading;
      var _this$props2 = this.props,
          page = _this$props2.page,
          debug = _this$props2.debug,
          handleViewerEvent = _this$props2.handleViewerEvent;
      return /*#__PURE__*/React.createElement(StyledComps.Page, {
        ref: this.pageRef
      }, media ? /*#__PURE__*/React.createElement(PdfField, {
        media: media,
        startLoading: this.startLoading,
        stopLoading: this.stopLoading,
        onResize: this.handleResize,
        style: {
          zIndex: 1
        }
      }) : null, !loading && regions && regions.length ? this.renderRegions(regions) : null, debug ? /*#__PURE__*/React.createElement(StyledComps.DebugPage, null, "".concat(page.name, " - ").concat(page['@id'])) : null);
    }
  }]);

  return PageRender;
}(Component);

_defineProperty(PageRender, "getDerivedStateFromProps", function (props, state) {
  return {
    media: props.page.background || null,
    regions: props.page.regions || []
  };
});

PageRender.propTypes = {
  issue: PropTypes.object.isRequired,
  page: PropTypes.shape({
    background: PropTypes.object,
    regions: PropTypes.array
  }).isRequired,
  onPageChange: PropTypes.func.isRequired,
  computeRegionStyle: PropTypes.func,
  startLoading: PropTypes.func,
  stopLoading: PropTypes.func,
  handleViewerEvent: PropTypes.func.isRequired,
  debug: PropTypes.bool,
  modalRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })])
};
PageRender.defaultProps = {
  issue: null,
  page: null,
  onPageChange: null,
  computeRegionStyle: null,
  debug: false,
  startLoading: function startLoading() {},
  stopLoading: function stopLoading() {}
};
export default PageRender;